import { Logout } from "./index"

export const ACCOUNT_ROUTES = [
  {
    path: "/logoutRedirect",
    component: Logout
  }
]
